import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export default function companyCategoryRestrictionModalReducer(state = initialState.companyCategoryRestrictionModal, action) {
    switch (action.type) {
        case types.SHOW_COMPANY_CATEGORY_RESTRICTION_MODAL:
            return {
                ...state,
                show: true,
                companyId: action.companyId,
                companyCategories: action.categories,
                count: action.count,
            };
        case types.HIDE_COMPANY_CATEGORY_RESTRICTION_MODAL:
            return {...initialState.companyCategoryRestrictionModal};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./web/src/reducers/company/companyCategoryRestrictionModalReducer.js